export default "__VITE_ASSET__Cbzd$qtx__"